import {
    clearMailListLoadDatapoint,
    getMailListLoadDatapointContext,
    isMailListLoadGenerationEnabled,
} from './mailListLoadDatapointGetterAndSetter';
import { addTimingsAndEndDatapointOnRender } from 'owa-analytics-shared';
import { DatapointStatus } from 'owa-analytics-types';
import { type OlkOrganizeAndActErrorCodes } from 'owa-error-codes';
import type { PerformanceDatapoint } from 'owa-analytics';
import { getStore as getListViewStore, type TableQueryType } from 'owa-mail-list-store';
import { isReadingPanePositionOff } from 'owa-mail-layout';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function endMailListLoadDatapoint(
    componentRendered: string,
    tableViewId: string,
    loadId?: number,
    shouldInvalidate?: boolean,
    overrideStatus?: DatapointStatus,
    error?: Error
): void {
    const context = getMailListLoadDatapointContext();
    if (
        !context ||
        (isMailListLoadGenerationEnabled() &&
            (context.tableViewId !== tableViewId || context.loadId !== loadId))
    ) {
        return;
    }

    const mailListLoadDp = context.datapoint;
    if (mailListLoadDp && !mailListLoadDp.hasEnded) {
        if (shouldInvalidate) {
            mailListLoadDp.invalidate();
        } else {
            addCustomDataToMailListLoadDatapoint(mailListLoadDp, componentRendered, tableViewId);

            if (
                overrideStatus === DatapointStatus.ServerError ||
                overrideStatus === DatapointStatus.ClientError
            ) {
                // The mail list resolved to an error state (e.g. EmptyML_Error / offline),
                // so end the datapoint with the mapped error status instead of success.
                mailListLoadDp.endWithError(overrideStatus, error ?? '24_0080');
            } else if (window.document && window.document.visibilityState == 'visible') {
                // Passing logOnly as false ends the datapoint after logging render end time if it has not already ended.
                addTimingsAndEndDatapointOnRender(mailListLoadDp, false /* logOnly */);
            } else {
                mailListLoadDp.end(undefined /* duration */, DatapointStatus.BackgroundSuccess);
            }
        }
    }
    clearMailListLoadDatapoint(context.tableViewId, context.loadId);
}

function addCustomDataToMailListLoadDatapoint(
    mailListLoadDp: PerformanceDatapoint,
    componentRendered: string,
    tableViewId: string
) {
    const tableView = getListViewStore().tableViews.get(tableViewId) ?? null;
    const autoSelectFirstRow = getUserConfiguration()?.UserOptions?.ShowReadingPaneOnFirstLoad;

    mailListLoadDp.addCustomData({
        cmp: componentRendered,
        lv: tableView?.tableQuery.listViewType,
        tq: tableView?.tableQuery.type,
        rpOn: !isReadingPanePositionOff(),
        fName: tableView?.tableQuery.type === 0 && folderIdToName(tableView?.tableQuery.folderId),
        auto: autoSelectFirstRow,
        errCode: tableView?.loadErrorCode,
    });
}
